/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guidevideo_Hidden_Badge1Inputs */

const vi_guidevideo_hidden_badge1 = /** @type {(inputs: Guidevideo_Hidden_Badge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang ẩn`)
};

/**

* @param {Guidevideo_Hidden_Badge1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_hidden_badge1 = /** @type {((inputs?: Guidevideo_Hidden_Badge1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Hidden_Badge1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_hidden_badge1(inputs)
});
export { guidevideo_hidden_badge1 as "guideVideo_hidden_badge" }